<template>
    <collapsible-card :title="'Company Interest'" class="companyInterestWidth" v-show="showChart" ref="cCard">
        <div class="cardContent centerChart chartContent">
            <div class="chart">
                <div id="interestChart" v-show="showChart"></div>
            </div>
        </div>
    </collapsible-card>
</template>

<script>
import Highcharts from 'highcharts';
import CollapsibleCard from '../CollapsibleCard.vue';

export default {
    name: "lease-chart-interest",
    components: {
        CollapsibleCard
    },
    data: () => ({
        showChart: false,
    }),
    methods: {
        createChart: function(interestData) {
            var globv = this;
            globv.showChart = false;
            if (interestData && interestData.length > 0) {
                let data = [];

                for (let i in interestData) {
                    data.push({
                        name: interestData[i]['company'],
                        y: interestData[i]['percent'],
                        custom: {
                            currOp: interestData[i]['currOper'] ? "Current Operator" : ""
                        }
                    });
                }

                 Highcharts.theme = {
                    colors: [
                        "#ED4553",
                        "#2B76DE",
                        "#6DDF76",
                        "#FC7C73",
                        "#409BC9",
                        "#F8B18B",
                        "#86E1E4",
                        "#F7D8BB",
                        "#CDEAE5",
                        "#F1FAEE"
                    ]
                }

                Highcharts.setOptions(Highcharts.theme);

                Highcharts.chart('interestChart', {
                    chart: {
                        type: 'pie',
                        backgroundColor: '#22293d'
                    },
                    credits: {
                        enabled: false,
                        credits: false
                    },
                    title: {
                        text: null
                    },
                    tooltip: {
                        pointFormat:
                            'Percentage: {point.y}% <br/>{point.options.custom.currOp}'
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                enabled: false,
                            },
                            showInLegend: true
                        }
                    },
                    legend: {
                        itemStyle: {
                            color: "#fff"
                        },
                        labelFormatter: function() {
                            return this.name + ": " + this.options.y + "%";
                        }
                    },
                    series: [{
                        name: 'Interest',
                        data: data
                    }]
                });

                globv.showChart = true;
                globv.$refs.cCard.adjustHeight();
            }
        },
        reset: function() {
            var globv = this;
            globv.showChart = false;
        }
    }
}
</script>

<style lang="scss">
.companyInterestWidth {
    min-width: 400px;
}
</style>